import { User, UserDisplayType } from '@mkp/user/models';
export interface LayoutElements {
  hasBorders: boolean;
  hasNavigation: boolean;
  hasTopHeader: boolean;
  hasFooter: boolean;
  isNavigationCollapsed: boolean | undefined;
  normalDocumentFlow: boolean;
}

export interface TopHeader {
  hasTopHeader: boolean;
  isLight: boolean;
  leftBoxContent?: HeaderItem[];
  rightBoxContent?: HeaderItem[];
  name: string | undefined;
}

export interface HeaderItem {
  type: HeaderItemType;
  options?: any;
}

export type HeaderItemType =
  | 'one_logo'
  | 'one_logo_link'
  | 'burger_menu'
  | 'dashboard_link'
  | 'go_back'
  | 'logo_divider'
  | 'login_link'
  | 'platform_logos'
  | 'selected_workspace'
  | 'customer_platform_logo'
  | 'lang_menu'
  | 'user_menu';

export interface LayoutInputParams {
  url: string;
  isMobile: boolean;
  isTablet: boolean;
  user: User | null | undefined;
}

type LayoutUserDisplayTypeMapping = Record<UserDisplayType, string>;

const DISPLAY_TYPE_CLASS: LayoutUserDisplayTypeMapping = {
  [UserDisplayType.CustomerJobs]: 'display-type-jobs',
  [UserDisplayType.CustomerJobUp]: 'display-type-jobup',
  [UserDisplayType.CustomerJobScout24]: 'display-type-jobscout24',
  [UserDisplayType.CustomerService]: '',
  [UserDisplayType.CustomerJobcloud]: '',
};

export const getLayoutUserDisplayTypeClass = (userDisplayType: UserDisplayType) =>
  DISPLAY_TYPE_CLASS[userDisplayType];
